import { Link } from 'react-router-dom'

interface LogoProps {
  className?: string
  logoSize?: string
}

export function Logo({ className = '', logoSize = 'h-8' }: LogoProps) {
  return (
    <Link to="/" className={`flex items-center ${className}`}>
      <img src="/bizora-logo.png" alt="Bizora" className={logoSize} />
      <span className="ml-2 text-xl font-bold text-neutral-900">
        bizora
      </span>
    </Link>
  )
}

